module.exports = __webpack_public_path__ + "media/images/emblems/GrabsSG-5db240007df2f8462f56869cc1d39320.png";